import config from '../config/config';

export const authenticate = (options) => fetch(`${config[process.env.APP_ENV].apiUrl}/en/api/rest-auth/login/`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    username: options.username,
    password: options.password,
  }),
})
  .then((response) => response.json())
  .then((r) => {
    if (r && r.key) {
      window.localStorage.setItem(config.LOCAL_STORAGE_KEYS.SESSION, r.key);
      return { accessGranted: true };
    }

    return { accessGranted: false };
  });

export const signOut = () => window.localStorage.removeItem(config.LOCAL_STORAGE_KEYS.SESSION);
export const sessionToken = () => window.localStorage.getItem(config.LOCAL_STORAGE_KEYS.SESSION);

export const fetchStaticToken = async (options) => {
  const {
    url,
    method,
    body,
  } = options;

  return fetch(url, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': config[process.env.APP_ENV].subscriptionKey,
    },
    body: JSON.stringify(body),
  });
};

export const swallowMsalErrors = (error) => {
  if (![
    'user_cancelled',
    'block_nested_popups',
    'access_denied',
    'interaction_in_progress',
    'interaction_required',
  ].includes(error.errorCode)) {
    console.error(error);
  }
};
